// extracted by mini-css-extract-plugin
export var card = "_6v-0";
export var failedIcon = "_6v-4";
export var failedIconBadge = "_6v-3";
export var icon = "_6v-1";
export var successIcon = "_6v-2";